import { LocaleResources } from 'locales';
import { Product } from 'src/models/product/schema';
import styles from '../index.module.scss';

type Props = {
  product: Product;
  quantity: number;
  localeResources: LocaleResources;
  closeZendesk: () => void;
  onAddToCart: (product: Product, quantity: number, source: string) => void;
  setIsVisible: (isVisible: boolean) => void;
};

export const CartAddButton: React.FC<Props> = ({
  product,
  quantity,
  localeResources,
  closeZendesk,
  onAddToCart,
  setIsVisible,
}) => (
  <button
    className={styles.button}
    onClick={() => {
      if (product && quantity) {
        onAddToCart(product, quantity, 'chemical_confirm_modal');
        closeZendesk();
        setIsVisible(false);
      }
    }}
  >
    {product?.medicalCanAbuse ? localeResources.cart.agree.addToCart : localeResources.cart.confirm.addToCart}
  </button>
);
